module.exports = __webpack_public_path__ + "img/ctrl-pauli-y-stub--.2ea93636.svg";